import { takeLatest, call, put } from "redux-saga/effects";
import { ENGINEER_ADD_REQUEST } from "../../actions/engineers";
import addEngineer from "../../../../../backend/oncall/partners/engineers/add";
import { push } from "react-router-redux/actions";
import { engineerAddError } from "../../actions/engineers";

const requestAdd = function*(action) {
  try {
    const result = yield call(
      addEngineer,
      action.payload.formData.firstName,
      action.payload.formData.lastName,
      action.payload.formData.workPhone,
      action.payload.formData.cellPhone,
      action.payload.formData.homePhone,
      parseInt(action.payload.formData.regionId, 10),
      action.payload.formData.enabled,
      parseInt(action.payload.formData.workPhonePriority, 10),
      parseInt(action.payload.formData.cellPhonePriority, 10),
      parseInt(action.payload.formData.homePhonePriority, 10),
    );
    yield put(push(`/engineer/edit/${result.id}`));
  } catch (error) {
    yield put(engineerAddError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(ENGINEER_ADD_REQUEST, requestAdd);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/engineers/request-add.js